import { render, staticRenderFns } from "./WsChip.vue?vue&type=template&id=0844e11f&scoped=true&"
import script from "./WsChip.vue?vue&type=script&lang=js&"
export * from "./WsChip.vue?vue&type=script&lang=js&"
import style0 from "./WsChip.vue?vue&type=style&index=0&id=0844e11f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0844e11f",
  null
  
)

export default component.exports